import { Company } from './Company';
import { Accountant } from './Accountant';
import { PrivacyAcceptance } from './PrivacyAcceptance';

export interface Entrepreneur {
  _id: string;
  name: string;
  mobile: string;
  email: string;
  aggreg8Token: string;
  companies: Company[];
  created: Date;
  privacyAcceptance?: PrivacyAcceptance;
}

export function isEntrepreneur(data: Entrepreneur | Accountant | null): data is Entrepreneur {
  if (!data) {
    return false;
  }
  return (data as Entrepreneur).companies !== undefined;
}
